import { useQuery } from "@tanstack/react-query";
import { getQueryFn } from "@/lib/queryClient";
import { Badge } from "@/components/ui/badge";
import { Link } from "wouter";
import { Skeleton } from "@/components/ui/skeleton";

interface RelatedTopicsProps {
  postId: number;
}

export function RelatedTopics({ postId }: RelatedTopicsProps) {
  const { data, isLoading } = useQuery({
    queryKey: ['/api/blog/topics', postId],
    queryFn: () => getQueryFn({ on401: "throw" })(`/api/blog/topics?postId=${postId}`),
    enabled: !!postId
  });
  
  if (isLoading) {
    return (
      <div className="mb-12">
        <h3 className="text-xl font-semibold mb-3">Related Topics</h3>
        <div className="flex flex-wrap gap-2">
          <Skeleton className="h-6 w-20" />
          <Skeleton className="h-6 w-16" />
          <Skeleton className="h-6 w-24" />
          <Skeleton className="h-6 w-16" />
          <Skeleton className="h-6 w-20" />
        </div>
      </div>
    );
  }
  
  const topics = data?.topics || [];
  
  if (topics.length === 0) {
    return null;
  }
  
  return (
    <div className="mb-12">
      <h3 className="text-xl font-semibold mb-3">Related Topics</h3>
      <div className="flex flex-wrap gap-2">
        {topics.map((topic, index) => (
          <Link 
            key={`${topic}-${index}`} 
            href={`/blog?search=${encodeURIComponent(topic)}`}
          >
            <Badge 
              variant="outline" 
              className="cursor-pointer hover:bg-primary/20"
            >
              {topic}
            </Badge>
          </Link>
        ))}
      </div>
    </div>
  );
}